// @owners { team: patients-team }
import { ActionSheetContext, MdSpacing, Separator } from '@alto/design-system';
import { type LineItem, LineItemTypeMap } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import React, { useCallback, useContext } from 'react';
import { getIsGskForYouUser } from '~shared/features/users/selectors/getIsGskForYouUser';
import { parseLineItem } from '~shared/helpers/pricingBreakdown';
import { useSelectorShared } from '~shared/store';
import { FeeDetailsActionSheet } from '../../checkout/components/select-date-card/FeeDetailsActionSheet';
import { PricingInfoRow } from '../../pricing-info/components/PricingInfoRow';

type Props = {
  readonly lineItem: LineItem;
  readonly noSeparator?: boolean;
};

export const PricingBreakdownOrderLineItem = ({ lineItem, noSeparator }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const isGskForYouUser = useSelectorShared(getIsGskForYouUser);
  const { label, originalPrice, shownPrice, savings, hasFee } = parseLineItem(lineItem);
  const hasNextDayMailFee = lineItem.key === LineItemTypeMap.NEXT_DAY_MAIL_FEE && hasFee;
  const showGskForYouFeeInfo = isGskForYouUser && hasNextDayMailFee;

  const handlePressGskForYouFeeInfo = useCallback(() => {
    setActiveActionSheet(<FeeDetailsActionSheet />);
  }, [setActiveActionSheet]);

  return (
    <>
      <MdSpacing />
      <PricingInfoRow
        label={label}
        originalPrice={originalPrice}
        savings={savings}
        price={shownPrice}
        onPressMoreInfo={showGskForYouFeeInfo ? handlePressGskForYouFeeInfo : undefined}
      />
      <MdSpacing />
      {noSeparator ? null : <Separator />}
    </>
  );
};
